<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 650"
    :fileAdd="checkData.image.length <= 12"
    :files="checkData.image"
    :delete-files="checkData.deleteFiles"
    maxFiles="3"
    maxFilesShow="3"
    :on-save="onSave"
  >
    <v-form ref="form" lazy-validation>
      <BaseInput
        v-model="checkData.text"
        :label="localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer']"
        :view="!editing"
        :rules="checkData.image.length ? ['required'] : null"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'

import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'TaxNumber',
  props: {
    editing: Boolean,
    tax_data: Object,
    employeeId: Number,
    onSave: Function,
    modal: Boolean,
  },
  components: { PersonalAreaTemplate },
  data: () => ({
    base64: [],
    checkData: {
      text: null,
      image: [],
      deleteFiles: [],
    },
  }),
  watch: {
    tax_data() {
      this.onActualData()
    },
    'checkData.image'() {
      for (let i in this.checkData.image) {
        if (this.checkData.image[i] === null || '' || undefined) {
          this.checkData.image.splice(i, 1)
        }
      }
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { taxNumber: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  mounted() {
    this.onActualData()
  },
  computed: {
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('user', ['onUserUpdateEmployeeData']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onActualData() {
      if (this.tax_data) {
        this.checkData.text = this.tax_data.text
        if (this.tax_data.image !== undefined) {
          this.checkData.image = this.tax_data.image
        }
      }
      this.onNavigationGuardianCheck({
        data: { taxNumber: this.checkData },
        overwrite: true,
      })
    },
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
        this.checkData.deleteFiles = []
      }
    },
    submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: file.type === 'application/pdf' ? null : 'cover',
          })
          .then((response) => {
            this.checkData.image[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.checkData.image.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('taxNumber')) {
          await Promise.all(
            this.checkData.image.map(async (file, index) => {
              if (typeof file !== 'string') {
                await this.submitFile(file, index)
              }
            }),
          )
          await this.deleteImageBD()
          let data = {
            tax_data: JSON.stringify({
              text: this.checkData.text,
              image: this.checkData.image,
            }),
          }
          resolve(data)
        } else resolve(true)
      })
    },
  },
}
</script>
